import { defineLocalStore } from '@/utils/localStore'
import { useRoute } from 'vue-router'
import { computed, reactive, shallowRef } from 'vue'
import { handleAsync, setSnackbar } from 'best-modules/plugins'
import { confirm } from 'best-modules/plugins/confirm'
import { pick } from 'lodash'
import { openDialog } from '@/dialog'
import { Plan } from '@/utils/types/plan'
import {
  auditsByPlan,
  detachAuditsToPlan,
  planSingle,
  planUpdate,
} from '@/requests/plan'

export const { initLocalStore: initPlan, useLocalStore: usePlan } =
  defineLocalStore('plan', () => {
    const route = useRoute()
    const planId = computed(() => {
      return Number(route.params.id)
    })
    const plan = reactive<Plan>({} as Plan)

    const planAuditList = shallowRef<any[]>([])

    const getPlan = () => {
      return handleAsync('getPlan', () => {
        return planSingle(planId.value).then(res => {
          Object.assign(plan, res)
        })
      })
    }

    const getAuditList = () => {
      return handleAsync('getAuditList', () => {
        return auditsByPlan(planId.value).then(res => {
          planAuditList.value = res
        })
      })
    }

    const auditCreate = () => {
      openDialog({
        name: 'Audit',
        action: 'create',
        dialogData: {
          plan: plan,
        },
        params: {
          cb: () => {
            setSnackbar({ text: 'Аудит успішно прикріплено' })
            getPlan()
          },
        },
      })
    }

    const auditAttach = () => {
      openDialog({
        name: 'AuditAttach',
        dialogData: {
          plan: plan,
        },
        params: {
          cb: res => {
            if (res) {
              planAuditList.value = res
              setSnackbar({ text: 'Аудит успішно прикріплено' })
              getPlan()
            }
          },
        },
      })
    }
    const auditDetach = (auditId: number[]) => {
      return confirm({ text: 'Ви впевнені, що хочете відкріпити аудит?' }).then(
        () => {
          return detachAuditsToPlan(planId.value, {
            auditIds: [auditId],
          }).then(res => {
            planAuditList.value = res
            setSnackbar({ text: 'Аудит успішно відкріплено' })
          })
        }
      )
    }

    const updateDocument = () => {
      return planUpdate(
        planId.value,
        pick(plan, ['name', 'approvedPlan'])
      ).then(res => {
        Object.assign(plan, res)
        setSnackbar({ text: 'Документ успішно оновлено' })
      })
    }

    handleAsync('init', () => {
      return Promise.all([getPlan(), getAuditList()])
    })

    return {
      plan,
      planAuditList,
      auditAttach,
      auditDetach,
      updateDocument,
      auditCreate,
    }
  })
